import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Colors from 'colors.json'

import Dropdown from 'components/Dropdown'
import Input from 'components/Input'
import Button from 'components/Button'
import { Form, Formik } from 'formik'

import { CreateMemberSchemas } from 'schemas/createMemberSchemas'
import { useCreateMember } from './useCreateMember'
import { MEMBER_GENDER, MEMBER_COUNTRY } from 'constants/filters'
import MerchantLookup from './HomeStoreSearch'

import { isQSRHClient } from 'setups/controller'
import { projectClient } from 'constants/project'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const { traderId } = useParams()
  const [isAddress, isAddressSet] = useState<boolean>(false)
  const {
    isLoading,
    initialValues,
    handleSubmitCreateMember,
  } = useCreateMember(Number(traderId), onCloseModal)

  // if (isLoading) return <></>

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={CreateMemberSchemas}
      onSubmit={(values, actions) => {
        console.log('Form submitted with values:', values)
        handleSubmitCreateMember(values, actions)
      }}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form>
            {!isQSRHClient(projectClient) && (
              <Input
                name="password"
                label="Password"
                labelClassName="text-gray-500"
              />
            )}
            <div className="mb-2">
              <div className="flex gap-4 items-center">
                <Input
                  name="firstName"
                  label="First Name"
                  labelClassName="text-gray-500 w-full"
                />
                <Input
                  name="lastName"
                  label="Last Name"
                  labelClassName="text-gray-500 w-full"
                />
                <Input
                  name="birthDate"
                  label="Birthday"
                  labelClassName="text-gray-500"
                  placeholder="YYYY-MM-DD"
                />
              </div>

              <br />

              <div className="flex gap-4 items-start">
                <div className="flex flex-col">
                  <Dropdown
                    title="Gender"
                    // defaultValue={
                    //   MEMBER_GENDER.filter(
                    //     (item) => String(item.value) === String(values.genderId)
                    //   )[0]
                    // }
                    options={MEMBER_GENDER}
                    className="w-40"
                    borderColor={errors.genderId ? 'red' : '#C4C4C4'}
                    onSelect={(item) => {
                      setFieldValue('genderId', Number(item.value))
                    }}
                  />
                  {errors.genderId && (
                    <div className="text-red text-xs mt-1 tracking-wider pb-2">
                      {errors.genderId}
                    </div>
                  )}
                </div>
                <Input
                  name="email"
                  label="Email"
                  labelClassName="text-gray-500"
                />
                <Input
                  name="mobile"
                  label="Mobile"
                  labelClassName="text-gray-500"
                />
              </div>
              <MerchantLookup
                isMerchantLookupToggle={true}
                title="Home Store"
                placeholder="Search by merchant name..."
                setFieldValue={(field, value) => {
                  if (field === 'storeId') {
                    // Set traderId for backend submission
                    setFieldValue('enrollmentTraderId', value)
                  }
                  // Set deviceCode for backend
                  setFieldValue('deviceCode', value)
                }}
              />
              <div className="flex gap-2 mb-4">
                <input
                  type={'checkbox'}
                  onClick={() => isAddressSet(!isAddress)}
                />
                <span className="font-light">Add more details</span>
              </div>
              {isAddress ? (
                <>
                  <Input
                    name="postalAddress.address1"
                    label="Address 1"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="postalAddress.address2"
                    label="Address 2"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="postalAddress.address3"
                    label="Address 3"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="postalAddress.address4"
                    label="Address 4"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="postalAddress.suburb"
                    label="Suburb"
                    labelClassName="text-gray-500"
                  />
                  <div className="flex gap-4 items-center">
                    <Input
                      name="postalAddress.state"
                      label="State"
                      labelClassName="text-gray-500"
                    />
                    <Input
                      name="postalAddress.city"
                      label="City"
                      labelClassName="text-gray-500"
                    />
                    <Input
                      name="postalAddress.postcode"
                      label="Postal Code"
                      labelClassName="text-gray-500"
                    />
                  </div>
                  {/* <div className="flex gap-4 items-center">
                    <Dropdown
                      title="Country"
                      options={MEMBER_COUNTRY}
                      className="w-40"
                      borderColor='#C4C4C4'
                      onSelect={(item) => {
                        setFieldValue('postalAddress.countryId', Number(item.value))
                      }}
                    />
                  </div> */}

                  <br />

                  <Input
                    name="comments"
                    label="Comments"
                    labelClassName="text-gray-500"
                  />
                  <div className="flex items-center mb-6">
                    <label htmlFor="flEmail" className="text-gray-500 mr-2 font-light">
                      Channel Email
                    </label>
                    <input
                      type="checkbox"
                      id="flEmail"
                      name="gdpr.flEmail"
                      className="mr-2"
                      // checked={values.gdpr.flEmail === 1}
                      onChange={(e) => {
                        setFieldValue('gdpr.flEmail', e.target.checked ? 1 : 0)
                      }}
                    />
                    <label htmlFor="flSms" className="text-gray-500 mr-2 font-light">
                      Channel SMS
                    </label>
                    <input
                      type="checkbox"
                      id="flSms"
                      name="gdpr.flSms"
                      className="mr-2"
                      // checked={values.gdpr.flSms === 1}
                      onChange={(e) => {
                        setFieldValue('gdpr.flSms', e.target.checked ? 1 : 0)
                      }}
                    />
                  </div>
                </>
              ) : null}
            </div>

            <footer className="flex justify-end pb-4 pl-4 pr-4">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Confirm</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
